<style lang="scss">
  @use "../../../../../assets/css/global.scss" as *;
  @use "../../../../../assets/css/_colors.scss" as *;
  @use "../../../../../assets/css/_mixins.scss" as *;
  .dropdownOption {
    align-items: center;
    cursor: pointer;
    border-radius: 0.625rem;
    display: flex;
    padding: 0.75rem 0.875rem;
    position: relative;
    user-select: none;
    justify-content: space-between;
    @extend .text-body-2-bold;

    &:hover {
      background-color: $light-blue;
    }

    &GroupLabel,
    &SelectAll {
      border-bottom: 1px solid $light-gray;
      border-radius: 0;
      color: $text-gray;
      margin-bottom: 0.25rem;

      &.disabled {
        cursor: default;
        pointer-events: none;
      }
    }

    &Selected {
      color: $primary-color;
      cursor: default;

      .dropdownOptionCheck {
        background-color: $primary-color;
        border-color: $primary-color;
        color: white !important;

        &::after {
          opacity: 1;
        }
      }
    }

    &Content {
      align-items: center;
      display: flex;
      gap: 0.5rem;
      flex-grow: 1;
      .secondaryLabel {
        color: $text-gray;
        font-size: 0.75rem;
      }
    }

    &Check {
      align-items: center;
      border: 2px solid $text-gray;
      border-radius: 2px;
      display: flex;
      margin-left: 1rem;
      justify-content: center;
      @include size(1rem);
      flex-shrink: 0;
      position: relative;

      &::after {
        content: "\f00c";
        font-size: 75%;
        font-family: "Font Awesome 6 Pro";
        position: absolute;
        top: 12.5%;
        left: 50%;
        transform: translate(-50%, -50%);
        opacity: 0;
        max-height: 100%;
      }
    }
  }
</style>

<script>
  import Avatar from "../Avatar.svelte";
  import IconContainer from "../IconContainer.svelte";

  export let option = {};
  export let isSelected = false;
  export let multiple = false;
  export let classList = "";
  export let displayInitials = false;
  export let isGroupLabel = false;
  export let addSecondaryLabel = false;
  export let secondaryLabelKey = "";

  const name = option.value === "selectAll" ? "All" : option.label;

  let lightenOnDropdownHover = false;
  const handleMouseOver = () => {
    // NOTE: only add this effect if an icon shares the background color with
    // the dropdown hover effect color - this is $light-blue
    if (["opens", "approveEmails"].includes(option.icon)) {
      lightenOnDropdownHover = true;
    }
  };
  const handleMouseLeave = () => {
    lightenOnDropdownHover = false;
  };
</script>

<div
  class="dropdownOption {classList}"
  class:dropdownOptionSelected={isSelected}
  on:click|stopPropagation
  on:keydown
  on:mouseover={handleMouseOver}
  on:mouseleave={handleMouseLeave}
  on:focus={handleMouseOver}
  on:blur={handleMouseLeave}
  tabindex="0"
  role="button"
>
  <div class="dropdownOptionContent">
    {#if option.image}
      <Avatar size="sm" image={option.image} />
    {:else if option.icon}
      <IconContainer icon={option.icon} size="sm" {lightenOnDropdownHover} />
    {:else if !option.image && displayInitials && !isGroupLabel}
      <Avatar size="sm" {name} displayInitials />
    {/if}
    <div class="labelContainer">
      <div class="primaryLabel">{option.label}</div>
      {#if addSecondaryLabel && option[secondaryLabelKey]}
        <div class="secondaryLabel">
          {option[secondaryLabelKey]}
        </div>
      {/if}
    </div>
  </div>
  {#if multiple}
    <div class="dropdownOptionCheck"></div>
  {/if}
</div>
